import React from "react";
import Header from "../components/Header";
import Main from "../components/Main";
import Footer from "../components/Footer";

function HomePage() {
  return (
    <div>
      <Header />
      <Main />
      <Footer />
    </div>
  );
}

export default HomePage;
